import { render, staticRenderFns } from "./SVGChange.vue?vue&type=template&id=bb0b64b2&scoped=true&"
import script from "./SVGChange.vue?vue&type=script&lang=js&"
export * from "./SVGChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0b64b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb0b64b2')) {
      api.createRecord('bb0b64b2', component.options)
    } else {
      api.reload('bb0b64b2', component.options)
    }
    module.hot.accept("./SVGChange.vue?vue&type=template&id=bb0b64b2&scoped=true&", function () {
      api.rerender('bb0b64b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGChange.vue"
export default component.exports